import { clearPendingAuthBridgeRequest } from '../auth-bridge-request';
import session from '../session';
import { storageKeys } from './storage-keys';

const clearStorage = (): void => {
    session.clearAccessToken();

    window.storage.removeItem(storageKeys.auth.isLoggedIn);
    window.storage.removeItem(storageKeys.user.isSeller);
    window.storage.removeItem(storageKeys.user.userSlug);
    window.storage.removeItem('FrMatReq');
    window.storage.removeItem(storageKeys.user.impersonated);
    window.storage.removeItem(storageKeys.user.oauthUserId);
    window.storage.removeItem(storageKeys.material.viewedMaterials);
    window.storage.removeItem('__paypal_storage__');
    clearPendingAuthBridgeRequest();

    try {
        window.sessionStorage.clear();
    } catch (e) {}
};

export default clearStorage;
